// import api from '../../api'
import * as types from '../mutation-types'

// initial state
const state = {
  id: '',
  logged_in: false
}

// getters
const getters = {
  userId: state => state.id,
  loggedIn: state => state.logged_in
}

// actions
const actions = {
  resetUser ({ commit }) {
    commit(types.LOGOUT_USER)
  }
}

// mutations
const mutations = {
  [types.STORE_FETCHED_USER] (state, uid) {
    state.id = uid
  },

  [types.LOGIN_USER] (state) {
    state.logged_in = true
  },

  [types.LOGOUT_USER] (state) {
    state.logged_in = false
    state.id = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js